/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminControllerCreateV1 } from '../fn/admin/admin-controller-create-v-1';
import { AdminControllerCreateV1$Params } from '../fn/admin/admin-controller-create-v-1';
import { adminControllerDeleteAdminV1 } from '../fn/admin/admin-controller-delete-admin-v-1';
import { AdminControllerDeleteAdminV1$Params } from '../fn/admin/admin-controller-delete-admin-v-1';
import { adminControllerFindByIdV1 } from '../fn/admin/admin-controller-find-by-id-v-1';
import { AdminControllerFindByIdV1$Params } from '../fn/admin/admin-controller-find-by-id-v-1';
import { adminControllerGetMeV1 } from '../fn/admin/admin-controller-get-me-v-1';
import { AdminControllerGetMeV1$Params } from '../fn/admin/admin-controller-get-me-v-1';
import { adminControllerLogoutV1 } from '../fn/admin/admin-controller-logout-v-1';
import { AdminControllerLogoutV1$Params } from '../fn/admin/admin-controller-logout-v-1';
import { adminControllerRefreshV1 } from '../fn/admin/admin-controller-refresh-v-1';
import { AdminControllerRefreshV1$Params } from '../fn/admin/admin-controller-refresh-v-1';
import { adminControllerResetPasswordV1 } from '../fn/admin/admin-controller-reset-password-v-1';
import { AdminControllerResetPasswordV1$Params } from '../fn/admin/admin-controller-reset-password-v-1';
import { adminControllerSearchOffsetV1 } from '../fn/admin/admin-controller-search-offset-v-1';
import { AdminControllerSearchOffsetV1$Params } from '../fn/admin/admin-controller-search-offset-v-1';
import { adminControllerSignInV1 } from '../fn/admin/admin-controller-sign-in-v-1';
import { AdminControllerSignInV1$Params } from '../fn/admin/admin-controller-sign-in-v-1';
import { adminControllerToggleBlockV1 } from '../fn/admin/admin-controller-toggle-block-v-1';
import { AdminControllerToggleBlockV1$Params } from '../fn/admin/admin-controller-toggle-block-v-1';
import { adminControllerUpdateV1 } from '../fn/admin/admin-controller-update-v-1';
import { AdminControllerUpdateV1$Params } from '../fn/admin/admin-controller-update-v-1';
import { AdminDto } from '../models/admin-dto';
import { AdminSearchResponseDto } from '../models/admin-search-response-dto';

@Injectable({ providedIn: 'root' })
export class AdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminControllerGetMeV1()` */
  static readonly AdminControllerGetMeV1Path = '/api/v1/admin';

  /**
   * 내정보 조회.
   *
   * (관리자) 내 정보를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerGetMeV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerGetMeV1$Response(params?: AdminControllerGetMeV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerGetMeV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 내정보 조회.
   *
   * (관리자) 내 정보를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerGetMeV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerGetMeV1(params?: AdminControllerGetMeV1$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerGetMeV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerSearchOffsetV1()` */
  static readonly AdminControllerSearchOffsetV1Path = '/api/v1/admin/search/offset';

  /**
   * 관리자 오프셋 기반 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerSearchOffsetV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerSearchOffsetV1$Response(params: AdminControllerSearchOffsetV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminSearchResponseDto>> {
    return adminControllerSearchOffsetV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 오프셋 기반 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerSearchOffsetV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerSearchOffsetV1(params: AdminControllerSearchOffsetV1$Params, context?: HttpContext): Observable<AdminSearchResponseDto> {
    return this.adminControllerSearchOffsetV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminSearchResponseDto>): AdminSearchResponseDto => r.body)
    );
  }

  /** Path part for operation `adminControllerFindByIdV1()` */
  static readonly AdminControllerFindByIdV1Path = '/api/v1/admin/{id}';

  /**
   * 관리자 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindByIdV1$Response(params: AdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindByIdV1(params: AdminControllerFindByIdV1$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerDeleteAdminV1()` */
  static readonly AdminControllerDeleteAdminV1Path = '/api/v1/admin/{id}';

  /**
   * 관리자 삭제.
   *
   * 관리자를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerDeleteAdminV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerDeleteAdminV1$Response(params: AdminControllerDeleteAdminV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return adminControllerDeleteAdminV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 삭제.
   *
   * 관리자를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerDeleteAdminV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerDeleteAdminV1(params: AdminControllerDeleteAdminV1$Params, context?: HttpContext): Observable<void> {
    return this.adminControllerDeleteAdminV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminControllerUpdateV1()` */
  static readonly AdminControllerUpdateV1Path = '/api/v1/admin/{id}';

  /**
   * 관리자 수정.
   *
   * 관리자 정보를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerUpdateV1$Response(params: AdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return adminControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 수정.
   *
   * 관리자 정보를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerUpdateV1(params: AdminControllerUpdateV1$Params, context?: HttpContext): Observable<boolean> {
    return this.adminControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `adminControllerSignInV1()` */
  static readonly AdminControllerSignInV1Path = '/api/v1/admin/signin';

  /**
   * 관리자 로그인.
   *
   * 관리자 로그인을 수행합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerSignInV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerSignInV1$Response(params: AdminControllerSignInV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accessToken'?: string;
'refreshToken'?: string;
}>> {
    return adminControllerSignInV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 로그인.
   *
   * 관리자 로그인을 수행합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerSignInV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerSignInV1(params: AdminControllerSignInV1$Params, context?: HttpContext): Observable<{
'accessToken'?: string;
'refreshToken'?: string;
}> {
    return this.adminControllerSignInV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'accessToken'?: string;
'refreshToken'?: string;
}>): {
'accessToken'?: string;
'refreshToken'?: string;
} => r.body)
    );
  }

  /** Path part for operation `adminControllerRefreshV1()` */
  static readonly AdminControllerRefreshV1Path = '/api/v1/admin/refresh';

  /**
   * 관리자 토큰 갱신.
   *
   * 관리자 토큰을 갱신합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerRefreshV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerRefreshV1$Response(params?: AdminControllerRefreshV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accessToken'?: string;
}>> {
    return adminControllerRefreshV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 토큰 갱신.
   *
   * 관리자 토큰을 갱신합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerRefreshV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerRefreshV1(params?: AdminControllerRefreshV1$Params, context?: HttpContext): Observable<{
'accessToken'?: string;
}> {
    return this.adminControllerRefreshV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'accessToken'?: string;
}>): {
'accessToken'?: string;
} => r.body)
    );
  }

  /** Path part for operation `adminControllerCreateV1()` */
  static readonly AdminControllerCreateV1Path = '/api/v1/admin/create';

  /**
   * 관리자 생성.
   *
   * 관리자를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerCreateV1$Response(params: AdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return adminControllerCreateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 생성.
   *
   * 관리자를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerCreateV1(params: AdminControllerCreateV1$Params, context?: HttpContext): Observable<boolean> {
    return this.adminControllerCreateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `adminControllerLogoutV1()` */
  static readonly AdminControllerLogoutV1Path = '/api/v1/admin/signout';

  /**
   * 로그아웃.
   *
   * 로그아웃합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerLogoutV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerLogoutV1$Response(params?: AdminControllerLogoutV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return adminControllerLogoutV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 로그아웃.
   *
   * 로그아웃합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerLogoutV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerLogoutV1(params?: AdminControllerLogoutV1$Params, context?: HttpContext): Observable<boolean> {
    return this.adminControllerLogoutV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `adminControllerResetPasswordV1()` */
  static readonly AdminControllerResetPasswordV1Path = '/api/v1/admin/{id}/reset-password';

  /**
   * 비밀번호 재설정.
   *
   * 비밀번호를 재설정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerResetPasswordV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerResetPasswordV1$Response(params: AdminControllerResetPasswordV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return adminControllerResetPasswordV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 비밀번호 재설정.
   *
   * 비밀번호를 재설정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerResetPasswordV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerResetPasswordV1(params: AdminControllerResetPasswordV1$Params, context?: HttpContext): Observable<void> {
    return this.adminControllerResetPasswordV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminControllerToggleBlockV1()` */
  static readonly AdminControllerToggleBlockV1Path = '/api/v1/admin/block-toggle/{id}';

  /**
   * 관리자 차단 | 차단해제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerToggleBlockV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerToggleBlockV1$Response(params: AdminControllerToggleBlockV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return adminControllerToggleBlockV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 차단 | 차단해제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerToggleBlockV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerToggleBlockV1(params: AdminControllerToggleBlockV1$Params, context?: HttpContext): Observable<boolean> {
    return this.adminControllerToggleBlockV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
